import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Input from "../../../../componentes/input/input";
import Textarea from "../../../../componentes/input/textarea";
import Button from "../../../../componentes/button/button";
import { CustomDropdown } from "../../../../componentes/dropdown/CustomDropdown";
import FuncionarioService from "../../../../services/resource/funcionarioService";
import FilialService from "../../../../services/resource/filialService";
import FortesFiscalService from "../../../../services/resource/fortesFiscalService";
import NovaSolicitacaoLayout from "../shared/NovaSolicitacaoLayout";
import { useRascunhoFormulario } from "../../Rascunho/RascunhoContext";
import { listaDoRascunho, mesclarComPadrao } from "../../../../utils/solicitacoes/rascunhoStorage";
import { enviarAnexosStaged } from "../../../../utils/solicitacoes/anexosStaged";
import { enviarComentariosStaged } from "../../../../utils/solicitacoes/comentariosStaged";
import { SETOR_OPTIONS } from "../../../../utils/solicitacoes/setores";
import { useCargoGerencial } from "../../../../hooks/solicitacoes/useCargoGerencial";

const funcionarioService = new FuncionarioService();
const filialService = new FilialService();
const fortesFiscalService = new FortesFiscalService();

const MOTIVO_OPTIONS = [
    { value: "PEDIDO_DEMISSAO", label: "Pedido de Demissão" },
    { value: "DEMISSAO_SEM_JUSTA_CAUSA", label: "Demissão sem Justa Causa" },
    { value: "DEMISSAO_COM_JUSTA_CAUSA", label: "Demissão com Justa Causa" },
    { value: "TERMINO_CONTRATO_EXPERIENCIA", label: "Término de Contrato de Experiência" },
    { value: "TERMINO_ANTECIPADO_EXPERIENCIA", label: "Término Antecipado de Experiência" },
    { value: "TERMINO_CONTRATO_APRENDIZ", label: "Término de Contrato de Aprendiz" },
];

const TIPO_AVISO_OPTIONS = [
    { value: "AVISO_TRABALHADO", label: "Aviso Trabalhado" },
    { value: "AVISO_INDENIZADO", label: "Aviso Indenizado" },
    { value: "SEM_AVISO", label: "Sem Aviso" },
];

const OPCAO_DESLIGAMENTO_OPTIONS = [
    { value: "SUBSTITUICAO", label: "Substituição" },
    { value: "REDUCAO_QUADRO", label: "Redução de Quadro" },
];

const TIPO_SUBSTITUTO_OPTIONS = [
    { value: "INTERNO", label: "Interno" },
    { value: "EXTERNO", label: "Externo" },
];

const MUDA_SETOR_OPTIONS = [
    { value: true, label: "Sim" },
    { value: false, label: "Não" },
];

const inicial = {
    unidadeId: null,
    funcionarioId: null,
    motivoDesligamento: null,
    dataPrevistaDesligamento: "",
    tipoAviso: null,
    opcaoDesligamento: null,
    justificativa: "",
    tipoSubstituto: null,
    substitutoFuncionarioId: null,
    substitutoIncluiPromocao: false,
    substitutoIncluiTransferencia: false,
    substitutoIncluiEnquadramento: false,
    substitutoCargoAtual: "",
    substitutoCargoProposto: "",
    substitutoSalarioAtual: "",
    substitutoSalarioProposto: "",
    substitutoDataPrevistaMudanca: "",
    substitutoSetorAtual: "",
    substitutoMudaDeSetor: false,
    substitutoSetorProposto: "",
    substitutoFilialPropostaId: null,
    substitutoEscalaAtual: "",
    substitutoEscalaProposta: "",
    substitutoBeneficios: "",
};

// Mesmo checkbox usado em NovaSolicitacaoPromocaoForm.jsx pro processo unificado de Promoção,
// Enquadramento e Transferência — duplicado aqui porque só é usado nesses 2 lugares.
function CheckboxTipoMudanca({ label, checked, onChange }) {
    return (
        <label className="flex items-center gap-2.5 px-3 py-2 border border-input rounded-md text-sm font-medium text-foreground/80 cursor-pointer hover:bg-muted">
            <input
                type="checkbox"
                checked={checked}
                onChange={e => onChange(e.target.checked)}
                className="h-4 w-4 rounded border-input text-primary focus:ring-2 focus:ring-primary/15"
            />
            {label}
        </label>
    );
}

export default function NovaSolicitacaoDesligamentoForm({ service, etapaInicialExigeAnexo, onCriada, encaminhar }) {
    const [form, setForm] = useState(inicial);
    const [anexos, setAnexos] = useState([]);
    const [comentarios, setComentarios] = useState([]);

    // Rascunho (botão "Salvar rascunho" da página) — só campos, anexos ficam de fora.
    useRascunhoFormulario(
        () => ({ form, comentarios }),
        dados => {
            setForm(mesclarComPadrao(inicial, dados.form));
            setComentarios(listaDoRascunho(dados.comentarios));
        },
    );
    const [funcionarios, setFuncionarios] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [enviando, setEnviando] = useState(false);
    const [cipa, setCipa] = useState(null);
    const [carregandoCipa, setCarregandoCipa] = useState(false);
    const { carregando: carregandoCargo, autorizado: autorizadoPorCargo, filial: filialSolicitante } = useCargoGerencial();

    useEffect(() => {
        filialService.listarAtivas().then(res => setUnidades(res.data)).catch(() => setUnidades([]));
    }, []);

    // Pré-preenche a filial com a do usuário logado assim que a consulta ao perfil retornar (a
    // busca é assíncrona, então isso não pode ficar num efeito com array de dependências vazio —
    // ele rodaria antes do valor chegar). Só preenche se o campo ainda estiver vazio, pra não
    // sobrescrever uma escolha manual feita enquanto a consulta ainda estava em andamento.
    useEffect(() => {
        if (!filialSolicitante) return;
        setForm(prev => (prev.unidadeId ? prev : { ...prev, unidadeId: filialSolicitante }));
    }, [filialSolicitante]);

    // Ao selecionar o funcionário a ser desligado, consulta ao vivo no Fortes se ele pertence à
    // CIPA — informação relevante pro RH antes de aprovar o desligamento (estabilidade provisória).
    useEffect(() => {
        if (!form.funcionarioId) {
            setCipa(null);
            return undefined;
        }
        setCarregandoCipa(true);
        setCipa(null);
        let cancelado = false;
        fortesFiscalService.buscarDadosDesligamento(form.funcionarioId)
            .then(res => {
                if (cancelado) return;
                const lista = res.data || [];
                setCipa(lista.length > 0 ? lista[0].cipa : null);
            })
            .catch(() => {
                if (!cancelado) setCipa(null);
            })
            .finally(() => {
                if (!cancelado) setCarregandoCipa(false);
            });
        return () => { cancelado = true; };
    }, [form.funcionarioId]);

    // Funcionário (tanto o desligado quanto o substituto) é sempre filtrado pela filial escolhida —
    // ao trocar a filial, a lista é recarregada e as seleções anteriores são descartadas.
    useEffect(() => {
        if (!form.unidadeId) {
            setFuncionarios([]);
            return;
        }
        funcionarioService.listar({ filialId: form.unidadeId })
            .then(res => setFuncionarios((res.data || []).filter(f => f.ativo)))
            .catch(() => setFuncionarios([]));
    }, [form.unidadeId]);

    const funcionarioSelecionado = funcionarios.find(f => f.id === form.funcionarioId) || null;
    const substituicaoInterna = form.opcaoDesligamento === "SUBSTITUICAO" && form.tipoSubstituto === "INTERNO";

    function set(campo, valor) {
        setForm(prev => ({ ...prev, [campo]: valor }));
    }

    function selecionarUnidade(unidadeId) {
        setForm(prev => ({ ...prev, unidadeId, funcionarioId: null, substitutoFuncionarioId: null }));
    }

    function validar() {
        if (!form.unidadeId || !form.funcionarioId || !form.motivoDesligamento || !form.dataPrevistaDesligamento
            || !form.tipoAviso || !form.opcaoDesligamento) {
            toast.error("Preencha todos os campos obrigatórios.");
            return false;
        }
        if (!form.justificativa.trim()) {
            toast.error("A justificativa é obrigatória.");
            return false;
        }

        if (form.opcaoDesligamento === "SUBSTITUICAO") {
            if (!form.tipoSubstituto) {
                toast.error("Informe se a substituição será interna ou externa.");
                return false;
            }
            if (substituicaoInterna) {
                if (!form.substitutoFuncionarioId) {
                    toast.error("Selecione o funcionário substituto.");
                    return false;
                }
                if (!form.substitutoIncluiPromocao && !form.substitutoIncluiTransferencia && !form.substitutoIncluiEnquadramento) {
                    toast.error("Selecione ao menos um tipo de mudança para o substituto: promoção, transferência ou enquadramento.");
                    return false;
                }
                if ((form.substitutoIncluiPromocao || form.substitutoIncluiEnquadramento)
                    && (!form.substitutoCargoAtual.trim() || !form.substitutoCargoProposto.trim())) {
                    toast.error("Informe o cargo atual e o cargo proposto do substituto.");
                    return false;
                }
                if (form.substitutoIncluiPromocao) {
                    if (!form.substitutoSalarioAtual || !form.substitutoSalarioProposto
                        || !form.substitutoDataPrevistaMudanca || !form.substitutoSetorAtual.trim()) {
                        toast.error("Preencha todos os campos obrigatórios da promoção do substituto.");
                        return false;
                    }
                    if (form.substitutoMudaDeSetor && !form.substitutoSetorProposto.trim()) {
                        toast.error("Informe o setor proposto do substituto, já que houve mudança de setor.");
                        return false;
                    }
                }
                if (form.substitutoIncluiTransferencia && !form.substitutoFilialPropostaId) {
                    toast.error("Selecione a filial de destino da transferência do substituto.");
                    return false;
                }
                if (form.substitutoIncluiEnquadramento) {
                    if (!form.substitutoEscalaAtual.trim() || !form.substitutoEscalaProposta.trim()) {
                        toast.error("Preencha todos os campos obrigatórios do enquadramento do substituto.");
                        return false;
                    }
                }
            }
        }

        if (etapaInicialExigeAnexo && anexos.length === 0) {
            toast.error("É necessário anexar pelo menos um documento para concluir esta etapa.");
            return false;
        }
        return true;
    }

    async function enviar() {
        if (!validar()) return;

        let usuarioEscolhidoId;
        try {
            usuarioEscolhidoId = await encaminhar("ETAPA_2_APROVACAO_GESTOR");
        } catch {
            return;
        }

        setEnviando(true);
        service.criarSolicitacao({
            ...form,
            usuarioEscolhidoId,
            tipoSubstituto: form.opcaoDesligamento === "SUBSTITUICAO" ? form.tipoSubstituto : null,
            substitutoSalarioAtual: substituicaoInterna && form.substitutoIncluiPromocao && form.substitutoSalarioAtual ? Number(form.substitutoSalarioAtual) : null,
            substitutoSalarioProposto: substituicaoInterna && form.substitutoIncluiPromocao && form.substitutoSalarioProposto ? Number(form.substitutoSalarioProposto) : null,
            substitutoSetorProposto: substituicaoInterna && form.substitutoIncluiPromocao && form.substitutoMudaDeSetor ? form.substitutoSetorProposto : null,
        })
            .then(async res => {
                const [{ falha: falhaAnexos }, { falha: falhaComentarios }] = await Promise.all([
                    enviarAnexosStaged(res.data.id, anexos),
                    enviarComentariosStaged(res.data.id, comentarios),
                ]);
                if (falhaAnexos.length > 0 || falhaComentarios.length > 0) {
                    const partes = [];
                    if (falhaAnexos.length > 0) partes.push(`${falhaAnexos.length} anexo(s) (${falhaAnexos.map(f => `${f.arquivo.name}: ${f.erro}`).join(", ")})`);
                    if (falhaComentarios.length > 0) partes.push(`${falhaComentarios.length} comentário(s)`);
                    toast.error(`Solicitação criada, mas houve falha ao enviar: ${partes.join(" e ")}.`);
                }
                onCriada(res.data);
            })
            .catch(error => console.error("Erro ao criar solicitação de desligamento", error))
            .finally(() => setEnviando(false));
    }

    if (carregandoCargo) {
        return (
            <div className="flex items-center justify-center py-16 text-sm text-muted-foreground">
                <i className="fa fa-spinner fa-spin mr-2" /> Verificando permissão...
            </div>
        );
    }

    if (!autorizadoPorCargo) {
        return (
            <div className="flex flex-col items-center gap-2 py-16 text-center">
                <i className="fa fa-lock text-muted-foreground text-xl" />
                <p className="text-sm text-foreground font-medium">Você não tem permissão para iniciar esta solicitação.</p>
                <p className="text-xs text-muted-foreground">Apenas Supervisores, Coordenadores ou Gerentes podem abrir este processo.</p>
            </div>
        );
    }

    return (
        <NovaSolicitacaoLayout
            anexos={anexos}
            onAnexosChange={setAnexos}
            comentarios={comentarios}
            onComentariosChange={setComentarios}
            etapaInicialExigeAnexo={etapaInicialExigeAnexo}
        >
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                <CustomDropdown
                    label="Filial"
                    required
                    value={form.unidadeId}
                    onChange={e => selecionarUnidade(e.value)}
                    options={unidades}
                    optionValue="id"
                    optionLabel="nome"
                    placeholder="Selecione"
                    filter
                />

                <div className="col-span-2">
                    <CustomDropdown
                        label="Funcionário"
                        value={form.funcionarioId}
                        onChange={e => set("funcionarioId", e.value)}
                        options={funcionarios}
                        optionValue="id"
                        required
                        optionLabel={f => f.cargo ? `${f.nome} — ${f.cargo}` : f.nome}
                        placeholder={form.unidadeId ? "Pesquisar funcionário" : "Selecione a filial primeiro"}
                        disabled={!form.unidadeId}
                        filter
                    />
                </div>

                {funcionarioSelecionado && (
                    <Input label="Cargo" disabled value={funcionarioSelecionado.cargo || "-"} />
                )}

                {funcionarioSelecionado && (
                    <div className="flex flex-col gap-1.5">
                        <label className="text-sm font-medium text-foreground/80">CIPA</label>
                        <div className="h-9 flex items-center">
                            {carregandoCipa ? (
                                <span className="text-xs text-muted-foreground"><i className="fa fa-spinner fa-spin mr-1" /> Consultando...</span>
                            ) : (
                                <span className={`text-xs font-medium rounded-full px-2.5 py-1 ${cipa ? "bg-amber-100 text-amber-800" : "bg-muted text-muted-foreground"}`}>
                                    {cipa ? "Pertence à CIPA" : "Não pertence à CIPA"}
                                </span>
                            )}
                        </div>
                    </div>
                )}

                <CustomDropdown label="Motivo" required value={form.motivoDesligamento} onChange={e => set("motivoDesligamento", e.value)} options={MOTIVO_OPTIONS} placeholder="Selecione" />

                <Input type="date" label="Data prevista para desligamento" required value={form.dataPrevistaDesligamento} onChange={e => set("dataPrevistaDesligamento", e.target.value)} />

                <CustomDropdown required label="Tipo de Aviso" value={form.tipoAviso} onChange={e => set("tipoAviso", e.value)} options={TIPO_AVISO_OPTIONS} placeholder="Selecione" />

                <CustomDropdown label="Opção de Desligamento" value={form.opcaoDesligamento} onChange={e => set("opcaoDesligamento", e.value)} options={OPCAO_DESLIGAMENTO_OPTIONS} placeholder="Selecione" />

                {form.opcaoDesligamento === "SUBSTITUICAO" && (
                    <div className="col-span-4 flex flex-col gap-4 border-l-2 border-primary/30 pl-4">
                        <div className="flex flex-col gap-1.5 max-w-xs">
                            <label className="text-sm font-medium text-foreground/80">Substituto <span className="text-destructive">*</span></label>
                            <CustomDropdown value={form.tipoSubstituto} onChange={e => set("tipoSubstituto", e.value)} options={TIPO_SUBSTITUTO_OPTIONS} placeholder="Selecione" />
                        </div>

                        {substituicaoInterna && (
                            <div className="flex flex-col gap-4">
                                <div className="flex items-start gap-2.5 px-3 py-2.5 bg-amber-50 border border-amber-200 rounded-md text-sm text-amber-800">
                                    <i className="fa fa-info-circle mt-0.5" />
                                    <span>Ao enviar, uma solicitação de promoção será aberta automaticamente para o substituto, com os dados preenchidos abaixo.</span>
                                </div>

                                <div>
                                    <label className="text-sm font-medium text-foreground/80 block mb-1.5">Funcionário substituto <span className="text-destructive">*</span></label>
                                    <CustomDropdown
                                        value={form.substitutoFuncionarioId}
                                        onChange={e => set("substitutoFuncionarioId", e.value)}
                                        options={funcionarios.filter(f => f.id !== form.funcionarioId)}
                                        optionValue="id"
                                        optionLabel={f => f.cargo ? `${f.nome} — ${f.cargo}` : f.nome}
                                        placeholder="Pesquisar funcionário"
                                        filter
                                    />
                                </div>

                                <div>
                                    <label className="text-sm font-medium text-foreground/80 block mb-1.5">Tipo de mudança <span className="text-destructive">*</span></label>
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                                        <CheckboxTipoMudanca label="Promoção (cargo/salário)" checked={form.substitutoIncluiPromocao} onChange={v => set("substitutoIncluiPromocao", v)} />
                                        <CheckboxTipoMudanca label="Transferência (filial)" checked={form.substitutoIncluiTransferencia} onChange={v => set("substitutoIncluiTransferencia", v)} />
                                        <CheckboxTipoMudanca label="Enquadramento (escala/turno)" checked={form.substitutoIncluiEnquadramento} onChange={v => set("substitutoIncluiEnquadramento", v)} />
                                    </div>
                                </div>

                                {(form.substitutoIncluiPromocao || form.substitutoIncluiEnquadramento) && (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        <Input label="Cargo atual" required value={form.substitutoCargoAtual} onChange={e => set("substitutoCargoAtual", e.target.value)} />
                                        <Input label="Cargo proposto" required value={form.substitutoCargoProposto} onChange={e => set("substitutoCargoProposto", e.target.value)} />
                                    </div>
                                )}

                                {form.substitutoIncluiPromocao && (
                                    <div className="flex flex-col gap-4 border-l-2 border-primary/30 pl-4">
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                            <Input type="number" min="0" step="0.01" label="Salário atual" required value={form.substitutoSalarioAtual} onChange={e => set("substitutoSalarioAtual", e.target.value)} />
                                            <Input type="number" min="0" step="0.01" label="Salário proposto" required value={form.substitutoSalarioProposto} onChange={e => set("substitutoSalarioProposto", e.target.value)} />
                                            <Input type="date" label="Data prevista para mudança" required value={form.substitutoDataPrevistaMudanca} onChange={e => set("substitutoDataPrevistaMudanca", e.target.value)} />
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                            <CustomDropdown label="Setor atual" required value={form.substitutoSetorAtual} onChange={e => set("substitutoSetorAtual", e.value)} options={SETOR_OPTIONS} placeholder="Selecione" />
                                            <div className="flex flex-col gap-1.5">
                                                <label className="text-sm font-medium text-foreground/80">Muda de setor <span className="text-destructive">*</span></label>
                                                <CustomDropdown value={form.substitutoMudaDeSetor} onChange={e => set("substitutoMudaDeSetor", e.value)} options={MUDA_SETOR_OPTIONS} />
                                            </div>
                                            {form.substitutoMudaDeSetor && (
                                                <CustomDropdown label="Setor proposto" required value={form.substitutoSetorProposto} onChange={e => set("substitutoSetorProposto", e.value)} options={SETOR_OPTIONS} placeholder="Selecione" />
                                            )}
                                        </div>
                                    </div>
                                )}

                                {form.substitutoIncluiTransferencia && (
                                    <div className="flex flex-col gap-4 border-l-2 border-primary/30 pl-4">
                                        <div>
                                            <label className="text-sm font-medium text-foreground/80 block mb-1.5">Filial de destino <span className="text-destructive">*</span></label>
                                            <CustomDropdown
                                                value={form.substitutoFilialPropostaId}
                                                onChange={e => set("substitutoFilialPropostaId", e.value)}
                                                options={unidades}
                                                optionValue="id"
                                                optionLabel="nome"
                                                placeholder="Informe a filial de destino"
                                                filter
                                            />
                                        </div>
                                    </div>
                                )}

                                {form.substitutoIncluiEnquadramento && (
                                    <div className="flex flex-col gap-4 border-l-2 border-primary/30 pl-4">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <Input label="Escala atual" required value={form.substitutoEscalaAtual} onChange={e => set("substitutoEscalaAtual", e.target.value)} />
                                            <Input label="Escala proposta" required value={form.substitutoEscalaProposta} onChange={e => set("substitutoEscalaProposta", e.target.value)} />
                                        </div>
                                    </div>
                                )}

                                <Textarea label="Benefícios para o substituto" value={form.substitutoBeneficios} onChange={e => set("substitutoBeneficios", e.target.value)} rows={2}
                                    placeholder="Ex: Plano de saúde, Vale alimentação, Auxílio combustível, Bônus..." />
                            </div>
                        )}
                    </div>
                )}

                <div className="col-span-4">
                    <Textarea label="Justificativa" required value={form.justificativa} onChange={e => set("justificativa", e.target.value)} rows={3} />
                </div>

                <div className="col-span-4">
                    <div className="flex justify-end">
                        <Button variant="blue" label="Solicitar desligamento" iconLeft="fa fa-paper-plane" loading={enviando} onClick={enviar} />
                    </div>
                </div>
            </div>
        </NovaSolicitacaoLayout>
    );
}
